import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const ServiceCard = ({ title, description, icon, link }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 border border-gray-100 group h-full flex flex-col">
      <div className="bg-psa-green-50 p-3 rounded-lg w-14 h-14 flex items-center justify-center mb-5 text-psa-green-600 group-hover:bg-psa-green-100 transition-colors duration-300">
        {icon}
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-3">{title}</h3>
      <p className="text-gray-600 mb-5 flex-grow">{description}</p>
      <Link
        to={link}
        className="inline-flex items-center text-psa-green-600 hover:text-psa-green-700 font-medium transition-colors duration-200 mt-auto"
      >
        Learn more
        <ArrowRight
          size={16}
          className="ml-2 group-hover:translate-x-1 transition-transform duration-300"
        />
      </Link>
    </div>
  );
};

export default ServiceCard;
